import * as cn from "classnames";
import * as React from "react";
import "./LoadingOverlay.css";
import { RocketComponent } from "./RocketComponent";
import { RocketSpinnerComponent } from "./RocketSpinnerComponent";

export interface LoadingOverlayProps {
    loading?: boolean;
    loadingFailed?: boolean;
    isAsideOverlay?: boolean;
    children?: React.ReactChild | React.ReactChild[];
    className?: string;
}

export function LoadingOverlay(props: LoadingOverlayProps) {
    if (props.isAsideOverlay && props.loading) {
        return null;
    }
    if (props.loadingFailed && !props.isAsideOverlay) {
        return <RocketComponent />;
    }
    if (props.loading && !props.isAsideOverlay) {
        return (
            <div className={cn("LoadingOverlay", props.className)}>
                <RocketSpinnerComponent />
                <span className="LoadingOverlay__loading">
                    Your data is being processed,<br />it'll be ready soon!
                </span>
            </div>
        );
    }

    return <>{props.children}</>;
}
